var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _vm.imgCover
          ? _c(
              "div",
              {
                staticClass: "imageModal",
                staticStyle: {
                  position: "fixed",
                  "z-index": "999",
                  "background-color": "rgba(0,0,0, .7)",
                  right: "0",
                  top: "0",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "close",
                    staticStyle: {
                      cursor: "pointer",
                      "font-size": "35px",
                      margin: "8px",
                    },
                    on: {
                      click: function ($event) {
                        _vm.imgCover = ""
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c("img", {
                  staticStyle: {
                    position: "fixed",
                    left: "50%",
                    top: "50%",
                    transform: "translateX(-50%) translateY(-50%)",
                    width: "450px",
                  },
                  attrs: { src: _vm.imgCover, alt: "Alternate Text" },
                }),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("b-card", { staticClass: "p-3", attrs: { "bg-variant": "Light" } }, [
        _c(
          "div",
          [
            _c("b-card-text", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticStyle: { width: "12%", "padding-left": "15px" } },
                  [
                    _vm.RequestSource == "search"
                      ? _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.ShowDetailPage(
                                  _vm.ElasticData._source.productReference
                                )
                              },
                            },
                          },
                          [
                            _c("b-img-lazy", {
                              ref: "searchImgRef",
                              staticStyle: {
                                float: "left",
                                border: "1px solid #bbb",
                                cursor: "pointer",
                              },
                              attrs: {
                                id: "searchImg",
                                center: "",
                                fluid: "",
                                blank: "",
                                "blank-src": "/images/loading_eclipse.gif",
                                src: _vm.CheckImageUrl(
                                  _vm.ElasticData._source.coverUrl,
                                  _vm.ElasticData._source.productReference,
                                  _vm.ElasticData._source.datasourceID
                                ),
                                width: "130",
                                height: "170",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.RequestSource == "details"
                      ? _c(
                          "div",
                          { on: { click: _vm.imgViewer } },
                          [
                            _c("b-img-lazy", {
                              ref: "detailImgRef",
                              staticStyle: {
                                float: "left",
                                border: "1px solid #bbb",
                                cursor: "pointer",
                              },
                              attrs: {
                                id: "detailsImg",
                                center: "",
                                fluid: "",
                                blank: "",
                                "blank-src": "/images/loading_eclipse.gif",
                                src: _vm.CheckImageUrl(
                                  _vm.ElasticData._source.coverUrl,
                                  _vm.ElasticData._source.productReference,
                                  _vm.ElasticData._source.datasourceID
                                ),
                                width: "130",
                                height: "170",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "66%", "margin-left": "1%" } },
                  [
                    _vm.ElasticData._source.contributors &&
                    _vm.ElasticData._source.contributors.length > 0 &&
                    _vm.RequestSource == "details"
                      ? _c("div", [
                          _vm.ElasticData._source.contributors &&
                          _vm.ElasticData._source.contributors.length > 0 &&
                          _vm.RequestSource == "details"
                            ? _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "contributors-section" },
                                  _vm._l(
                                    _vm.ElasticData._source.contributors,
                                    function (contributor) {
                                      return _c(
                                        "a",
                                        {
                                          key: _vm.index,
                                          staticClass: "filter-link",
                                          attrs: {
                                            href: _vm.generateItemLink(
                                              contributor.contributorName,
                                              "contributors"
                                            ),
                                          },
                                        },
                                        [_vm._v(_vm._s(contributor.keyNames))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ElasticData._source.contributorStatement &&
                    _vm.ElasticData._source.contributorStatement != "-" &&
                    _vm.RequestSource == "search"
                      ? _c(
                          "p",
                          {
                            staticClass: "ElasticData_Author",
                            staticStyle: {
                              "margin-bottom": "0.2rem !important",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.Decodehtml(
                                  _vm.ElasticData._source.contributorStatement
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.contributors, function (contributor, index) {
                      return !_vm.ElasticData._source.contributorStatement
                        ? _c("span", [
                            contributor.keyNames != "-"
                              ? _c(
                                  "span",
                                  { staticClass: "ElasticData_Author" },
                                  [_vm._v(_vm._s(contributor.keyNames))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            index + 1 < _vm.contributors.length
                              ? _c("span", [_vm._v(",")])
                              : _vm._e(),
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: { "margin-bottom": "0.2rem !important" },
                        attrs: { id: "distinctiveTitle" },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "Main_Title",
                            on: {
                              click: function ($event) {
                                return _vm.ShowDetailPage(
                                  _vm.ElasticData._source.productReference
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.Decodehtml(
                                  _vm.ElasticData._source.distinctiveTitle
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          "font-style": "italic",
                          "text-align": "left !important",
                          "margin-bottom": "0.2rem !important",
                        },
                      },
                      [_vm._v(_vm._s(_vm.ElasticData._source.subtitle))]
                    ),
                    _vm._v(" "),
                    _vm.isJournal()
                      ? _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-bottom": "0.2rem !important",
                            },
                          },
                          [
                            _vm.ElasticData._source.volumeYear
                              ? _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.translationKeywords.volume) + ":"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(
                              _vm._s(_vm.ElasticData._source.volumeYear) +
                                "\n                            "
                            ),
                            _vm.ElasticData._source.volumeYear &&
                            _vm.ElasticData._source.publicationFrequency
                              ? _c("span", [_vm._v(", ")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.ElasticData._source.publicationFrequency
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ElasticData._source
                                        .publicationFrequency
                                    )
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ElasticData._source.editionStatement
                                    )
                                  ),
                                ]),
                          ]
                        )
                      : _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-bottom": "0.2rem !important",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.ElasticData._source.editionStatement)
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", [
                      _vm.ElasticData._source.publishers
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "d-flex justify-center" },
                              _vm._l(
                                _vm.ElasticData._source.publishers,
                                function (publisher) {
                                  return _c(
                                    "a",
                                    {
                                      key: _vm.index,
                                      staticClass: "filter-link",
                                      attrs: {
                                        href: _vm.generateItemLink(
                                          publisher,
                                          "publisher"
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(publisher))]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.ElasticData._source.publicationYear <= 2300 &&
                    _vm.ElasticData._source.publicationYear >= 1000 &&
                    _vm.ElasticData._source.availability_Text == "Available"
                      ? _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-bottom": "0.2rem !important",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translationKeywords.publicationDate) +
                                ": " +
                                _vm._s(
                                  _vm.ElasticData._source.publicationDateDisplay
                                )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    (_vm.ElasticData._source.availability ==
                      "derzeit nicht lieferbar" ||
                      _vm.ElasticData._source.availability ==
                        "Will be orderable") &&
                    _vm.ElasticData._source.expectedShipDate
                      ? _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-bottom": "0.2rem !important",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.translationKeywords.expectedShipDate) +
                                ": " +
                                _vm._s(_vm.ElasticData._source.expectedShipDate)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticStyle: { "margin-bottom": "0.2rem !important" } },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.ElasticData._source.mediaType ==
                                  "Journal",
                                expression:
                                  "ElasticData._source.mediaType == 'Journal'",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.translationKeywords.journal))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.ElasticData._source.mediaType !=
                                  "Journal",
                                expression:
                                  "ElasticData._source.mediaType != 'Journal'",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.ElasticData._source.productForm))]
                        ),
                        _vm._v(" "),
                        _vm.ElasticData._source.productFormDetail &&
                        _vm.ElasticData._source.productFormDetail.length > 0 &&
                        _vm.ElasticData._source.productFormDetail[0]
                          ? _c(
                              "span",
                              { staticStyle: { "margin-left": "-3px" } },
                              [
                                _vm._v(
                                  "\n                                , " +
                                    _vm._s(
                                      _vm.ElasticData._source
                                        .productFormDetail[0]
                                    ) +
                                    ",\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ElasticData._source.productFormDescription &&
                        _vm.ElasticData._source.productFormDetail &&
                        _vm.ElasticData._source.productFormDetail.length > 0 &&
                        !_vm.ElasticData._source.productFormDetail[0]
                          ? _c(
                              "span",
                              { staticStyle: { "margin-left": "-3px" } },
                              [
                                _vm._v(
                                  "\n                                , " +
                                    _vm._s(
                                      _vm.ElasticData._source
                                        .productFormDescription
                                    ) +
                                    ",\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ElasticData._source.epubType
                          ? _c(
                              "span",
                              { staticStyle: { "margin-left": "-3px" } },
                              [
                                _vm._v(
                                  ", " +
                                    _vm._s(_vm.ElasticData._source.epubType)
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ElasticData._source.pages != null,
                                expression: "ElasticData._source.pages!=null",
                              },
                            ],
                            staticStyle: { "margin-left": "-3px" },
                          },
                          [
                            _vm._v(
                              ", " +
                                _vm._s(_vm.ElasticData._source.pages) +
                                " " +
                                _vm._s(_vm.translationKeywords.pages) +
                                ","
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ElasticData._source.duration != null,
                                expression:
                                  "ElasticData._source.duration!=null",
                              },
                            ],
                            staticStyle: { "margin-left": "-3px" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.translationKeywords.duration) +
                                ": " +
                                _vm._s(_vm.ElasticData._source.duration) +
                                ","
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ElasticData._source.fileSize != null,
                                expression:
                                  "ElasticData._source.fileSize!=null",
                              },
                            ],
                            staticStyle: { "margin-left": "-3px" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.translationKeywords.filesize) +
                                ": " +
                                _vm._s(_vm.ElasticData._source.fileSize) +
                                ","
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.ElasticData._source.publicationLanguages,
                          function (lang, index) {
                            return _vm.ElasticData._source.publicationLanguages
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(lang) +
                                      "\n                                "
                                  ),
                                  index >= 0 &&
                                  index <
                                    _vm.ElasticData._source.publicationLanguages
                                      .length -
                                      1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "-3px",
                                          },
                                        },
                                        [_vm._v(", ")]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.ElasticData._source.isbN13Hyphens ==
                                    null && !_vm.ElasticData._source.mediaType,
                                expression:
                                  "ElasticData._source.isbN13Hyphens==null && !ElasticData._source.mediaType",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.ElasticData._source.productReference)
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.ElasticData._source.mediaType != null &&
                                  _vm.isJournal(),
                                expression:
                                  "ElasticData._source.mediaType !=null && isJournal()",
                              },
                            ],
                          },
                          [_vm._v(", " + _vm._s(_vm.ElasticData._source.issn))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.ElasticData._source.mediaType,
                                expression: "!ElasticData._source.mediaType",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.ElasticData._source.isbN13Hyphens)
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.ElasticData._source.productReference
                      ? _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-bottom": "0.2rem !important",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.ElasticData._source.productReference)
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.ShowRelated,
                            expression: "ShowRelated",
                          },
                        ],
                        staticStyle: { "padding-top": "15px" },
                      },
                      [
                        _c(
                          "table",
                          _vm._l(
                            _vm.relatedProducts,
                            function (relatedProduct) {
                              return _c("tr", [
                                relatedProduct.isbN13
                                  ? _c(
                                      "td",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-size": "13px",
                                              "font-style": "italic",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  relatedProduct.relationCode
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "relatedProduct",
                                        on: {
                                          click: function ($event) {
                                            return _vm.RelatedProductSearch(
                                              relatedProduct.isbN13
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(relatedProduct.isbN13)
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ElasticData._source.numberOfPieces
                      ? _c(
                          "div",
                          { staticClass: "mt-3" },
                          [
                            _c("b", { staticClass: "mb-1 d-inline-block" }, [
                              _vm._v(
                                _vm._s(_vm.translationKeywords.NumberOfPieces) +
                                  " " +
                                  _vm._s(_vm.ElasticData._source.numberOfPieces)
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.ElasticData._source.relatedProducts,
                              function (product) {
                                return _c("div", [
                                  _c("b", [
                                    _vm._v(_vm._s(product.productForm)),
                                  ]),
                                  _vm._v(": "),
                                  _c("span", [
                                    _vm._v(_vm._s(product.productReference)),
                                  ]),
                                ])
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.pdfDownload
                      ? _c(
                          "div",
                          {
                            staticClass: "pdf-button p-0",
                            attrs: { title: _vm.translationKeywords.exportPdf },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-file-pdf-o mb-2 mt-2 pdf-icon",
                              staticStyle: { "font-size": "25px" },
                              on: {
                                click: function ($event) {
                                  return _vm.downloadPdf(
                                    _vm.ElasticData._source.productReference
                                  )
                                },
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-modal",
                      {
                        ref: "my-modal",
                        attrs: {
                          "hide-footer": "",
                          "hide-header": "",
                          "no-close-on-esc": "",
                          "no-close-on-backdrop": "",
                          centered: "",
                          size: "md",
                        },
                      },
                      [
                        _vm.downloading
                          ? _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "500",
                                    "font-size": "18px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translationKeywords.Downloading
                                    ) + " "
                                  ),
                                ]
                              ),
                              _vm._v(" \n                                "),
                              _c("img", {
                                attrs: {
                                  height: "25",
                                  width: "25",
                                  src: "/Images/icons8-download.gif",
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.succeded
                          ? _c("div", [
                              _c("i", {
                                staticClass:
                                  "dx-icon-check dx-icon-custom-style",
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "500",
                                    "font-size": "18px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translationKeywords
                                        .PdfDownloadedSuccessfully
                                    ) + " "
                                  ),
                                ]
                              ),
                              _vm._v("  \n\n                            "),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.pdfError
                          ? _c("div", [
                              _c("i", {
                                staticClass:
                                  "dx-icon-remove dx-icon-custom-style",
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-weight": "500",
                                    "font-size": "18px",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.translationKeywords.downloadFailed
                                    )
                                  ),
                                ]
                              ),
                              _vm._v("  \n\n                            "),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "20%", "text-align": "right" } },
                  [
                    !_vm.ShowJournalPrices || !_vm.isJournal()
                      ? _c(
                          "div",
                          {
                            attrs: {
                              id: `${_vm.ElasticData._source.productReference}_price`,
                            },
                          },
                          [
                            _vm.ElasticData._source.price &&
                            _vm.ElasticData._source.price.priceDescription
                              ? _c(
                                  "span",
                                  [
                                    _c("b-img", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticStyle: {
                                        "margin-top": "-10px",
                                        width: "25px",
                                      },
                                      attrs: {
                                        src: "/Images/info-icon.svg",
                                        title:
                                          _vm.ElasticData._source.price
                                            .priceDescription,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "price-options-container" },
                              [
                                !_vm.ElasticData._source.unpricedItemType
                                  ? _c("div", { staticClass: "price-option" }, [
                                      _c(
                                        "span",
                                        { staticClass: "ElasticData_Price" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "price-title" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.getPriceTypeDesc())
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "price-amount" },
                                            [
                                              !_vm.ElasticData._source
                                                .hasCustomCalculatedPrice
                                                ? _c("div", [
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ElasticData
                                                                ._source
                                                                .finalPrice
                                                                .priceAmount +
                                                                " " +
                                                                _vm.ElasticData
                                                                  ._source
                                                                  .finalPrice
                                                                  .currency
                                                            ) + " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type",
                                                          },
                                                          [
                                                            _vm.ElasticData
                                                              ._source
                                                              .isExecludingTaxPrice
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "(Preis vom Lieferanten)"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "(inkl. MwSt.)"
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isJournal()
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.showJournalPrice()
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isJournal()
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type",
                                                          },
                                                          [
                                                            _vm.ElasticData
                                                              ._source
                                                              .isExecludingTaxPrice
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "(Preis vom Lieferanten)"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "(inkl. MwSt.)"
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ])
                                                : _vm.ElasticData._source
                                                    .hasCustomCalculatedPrice
                                                ? _c("div", [
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-amount-discount",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .ElasticData
                                                                    ._source
                                                                    .finalPrice
                                                                    .orginal_PriceAmount +
                                                                    " " +
                                                                    _vm
                                                                      .ElasticData
                                                                      ._source
                                                                      .finalPrice
                                                                      .currency
                                                                ) + " "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type price-type-discount",
                                                          },
                                                          [
                                                            _vm.ElasticData
                                                              ._source
                                                              .isExecludingTaxPrice
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "(Preis vom Lieferanten)"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "(inkl. MwSt.)"
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 mt-2 price-discount-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Our exclusive price for you *"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-amount",
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .ElasticData
                                                                    ._source
                                                                    .finalPrice
                                                                    .priceAmount +
                                                                    " " +
                                                                    _vm
                                                                      .ElasticData
                                                                      ._source
                                                                      .finalPrice
                                                                      .currency
                                                                ) + " "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type",
                                                          },
                                                          [
                                                            _vm.ElasticData
                                                              ._source
                                                              .isExecludingTaxPrice
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "(Preis vom Lieferanten)"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "(inkl. MwSt.)"
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ])
                                                : _c("div", [
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c("span", [
                                                          _c("s", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formatCurrency(
                                                                  _vm
                                                                    .ElasticData
                                                                    ._source
                                                                    .finalPrice
                                                                    .priceAmount
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type",
                                                          },
                                                          [
                                                            _c("s", [
                                                              _vm.ElasticData
                                                                ._source
                                                                .isExecludingTaxPrice
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "(Preis vom Lieferanten)"
                                                                    ),
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "(inkl. MwSt.)"
                                                                    ),
                                                                  ]),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c("br"),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      { staticClass: "label" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .translationKeywords
                                                              .calculatedPriceLabel
                                                          )
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                            },
                                                            attrs: {
                                                              title:
                                                                _vm
                                                                  .translationKeywords
                                                                  .calculatedPriceTitle,
                                                            },
                                                          },
                                                          [_vm._v(" *")]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.ElasticData
                                                                ._source
                                                                .calculatedPrice
                                                                .formattedPrice +
                                                                " " +
                                                                _vm.ElasticData
                                                                  ._source
                                                                  .finalPrice
                                                                  .currency
                                                            ) + " "
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isJournal() &&
                                                    _vm.ElasticData._source
                                                      .finalPrice &&
                                                    _vm.ElasticData._source
                                                      .finalPrice.priceAmount
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type",
                                                          },
                                                          [
                                                            _vm.ElasticData
                                                              ._source
                                                              .isExecludingTaxPrice
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "(Preis vom Lieferanten)"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "(inkl. MwSt.)"
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isJournal()
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.showJournalPrice()
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isJournal()
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "price-type",
                                                          },
                                                          [
                                                            _vm.ElasticData
                                                              ._source
                                                              .isExecludingTaxPrice
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "(Preis vom Lieferanten)"
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    "(inkl. MwSt.)"
                                                                  ),
                                                                ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.ElasticData._source.finalPrice
                                            .converted
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "red",
                                                    cursor: "pointer",
                                                  },
                                                  attrs: {
                                                    title:
                                                      _vm.translationKeywords
                                                        .convertedPrice,
                                                  },
                                                },
                                                [_vm._v(" *")]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.isJournal()
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "price-description",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.showPriceDescription()
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isJournal() &&
                                      _vm.ElasticData._source.prices.length > 1
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "more-prices",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.ShowDetailPage(
                                                    _vm.ElasticData._source
                                                      .productReference
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Weitere Preise anzeigen")]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.MapUnpricedItemTypeCode(
                                              _vm.ElasticData._source
                                                .unpricedItemType
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.ShowJournalPrices && _vm.isJournal()
                      ? _c(
                          "div",
                          {
                            attrs: {
                              id: `${_vm.ElasticData._source.productReference}_price`,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "price-options-container radio product-details",
                              },
                              _vm._l(
                                _vm.ElasticData._source.prices,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "price-option radio" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "price-title" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getPriceTypeDesc(
                                                item.priceTypeCode
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("label", [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            name: "optradio",
                                          },
                                          domProps: {
                                            checked: index == 0,
                                            value: item,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.onSelectedPriceChanged(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.showJournalPrice(item))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "price-description" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.showPriceDescription(item)
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-bottom": "4px" } }, [
                      _vm.ElasticData._source.availability
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-left": "5px",
                                "text-align": "right",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.ElasticData._source.availability)
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", {
                        class: _vm.ElasticData._source.availability_Text,
                        attrs: {
                          id:
                            "availability-" +
                            _vm.ElasticData._source.productReference,
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("p"),
                    _c(
                      "div",
                      { staticClass: "item-btns" },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ShowShoppingCartStatus,
                                expression: "ShowShoppingCartStatus",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.ElasticData._source.item_inShoppingCart
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.ItemInShoppingCart
                          ? _c("img", {
                              staticClass: "cart-img pb-1",
                              attrs: {
                                src: "/Images/cart-icon.jpg",
                                id: _vm.ElasticData._source.productReference,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.AddToShoopingCart
                          ? _c("b-spinner", {
                              staticClass: "cart-loader",
                              attrs: {
                                variant: "",
                                label: "Text Centered",
                                id:
                                  "ShoppingCartLoader-" +
                                  _vm.ElasticData._source.productReference,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.ElasticData._source.availability_Text !==
                          "NotAvailable") &
                        _vm.isODB() &
                        _vm.isAuthorized
                          ? _c("oDB-form", {
                              attrs: {
                                ElasticData: _vm.ElasticData,
                                mode: "ODB",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.CheckIsPriceless() && !_vm.isODB()
                          ? _c("oDB-form", {
                              attrs: {
                                ElasticData: _vm.ElasticData,
                                mode: "Priceless",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ElasticData._source.availability_Text !==
                          "NotAvailable" &&
                        !_vm.isAuthorized &&
                        _vm.isODB()
                          ? _c("input", {
                              staticClass: "test-access-btn w-100",
                              attrs: {
                                ElasticData: _vm.ElasticData,
                                mode: "ODB",
                                "data-isbn":
                                  _vm.ElasticData._source.productReference,
                                type: "button",
                                value: "Bestellung",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayAddTocart() && !_vm.CheckIsPriceless()
                          ? _c("input", {
                              staticClass: "first-btn w-100",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                type: "button",
                                id:
                                  "btnShoppingCart-" +
                                  _vm.ElasticData._source.productReference,
                                value: _vm.translationKeywords.addShoppingCart,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.AddToShoppingCart(
                                    _vm.ElasticData._source.productReference,
                                    _vm.ElasticData._source.availability_Text
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isJournal() && _vm.isAddedToCart()
                          ? _c("input", {
                              staticClass: "first-btn w-100",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                type: "button",
                                id:
                                  "btnShoppingCart-" +
                                  _vm.ElasticData._source.productReference,
                                value: _vm.translationKeywords.goToCart,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.goToCart()
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isJournal() && !_vm.ShowJournalPrices
                          ? _c("input", {
                              staticClass: "first-btn w-100",
                              staticStyle: { "margin-bottom": "5px" },
                              attrs: {
                                type: "button",
                                value: _vm.translationKeywords.goToDetailPage,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.ShowDetailPage(
                                    _vm.ElasticData._source.productReference
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isODB() &&
                        !_vm.isJournal() &&
                        !_vm.CheckIsPriceless()
                          ? _c("br")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("wishlistButton"),
                        _vm._v(" "),
                        _vm._t("DeleteButton"),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("p"),
                    _vm._v(" "),
                    _c("p", [
                      _c("img", {
                        staticStyle: { float: "right", "margin-top": "-7px" },
                        attrs: {
                          src: _vm.GetLibraryStatus(
                            _vm.ElasticData._source.libraryStatus
                              .itemLibrary_Status
                          ),
                          width: "24",
                          title:
                            _vm.ElasticData._source.libraryStatus
                              .itemLibrary_ToolTip,
                        },
                      }),
                    ]),
                  ]
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }